const { middleware: sagaThunkMiddleware } = require('redux-saga-thunk');
const thunkMiddleware = require('redux-thunk').default;

const req = require.context('.', true, /\.\/.+\/middleware\.js$/);

module.exports = req.keys()
  .map(key => req(key).default)
  .concat([
    sagaThunkMiddleware,
    thunkMiddleware,
  ]);



// WEBPACK FOOTER //
// ./src/store/middlewares.js